// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountSetupController = function ($scope, $routeParams, $rootScope, $location, $http, AccountSetup, CheckPasswordStrength, Throttle) {
    $scope.accountsetup = AccountSetup.get({ token: $routeParams.token }, function () { }, function () { $location.path("/login"); });
    $scope.accountsetup.Status = 'Estimate';
    $scope.accessToken = "";
    $scope.refreshToken = "";
    var estimationResult = Throttle(CheckPasswordStrength, 1000, function (data) { $scope.estimationResult = data; });

    $scope.preview = function () {
        estimationResult.request($scope.accountsetup.Password);
    };
    $scope.save = function () {
        if (!$rootScope.isValid($scope.form))
            return;

        $scope.accountsetup.$save({ token: $routeParams.token });
        $location.path("/login");
    };
};
AccountSetupController.$inject = ['$scope', '$routeParams', '$rootScope', '$location', '$http', 'AccountSetup','CheckPasswordStrength', 'Throttle'];
